module.exports = {"data":{"site":{"siteMetadata":{"title":"Phanor Coll - Fullstack Developer","author":"Phanor Coll","description":"gopher in action"}}},"layoutContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/layout-ebook-layout.json
// module id = 139
// module chunks = 60335399758886 216277985284727